// app/javascript/controllers/table_sort_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["header", "row"]
  static values = { direction: { type: String, default: "desc" } }

  connect() {
    this.updateIcon();
  }

  toggle() {
    this.directionValue = this.directionValue === "desc" ? "asc" : "desc";
    this.sort();
  }

  sort() {
    const tbody = this.rowTargets[0]?.parentElement;
    if (!tbody) return;

    const dir = this.directionValue === "asc" ? 1 : -1;
    const rows = this.rowTargets.slice().sort((a, b) => {
      const av = Number(a.dataset.sortValue);
      const bv = Number(b.dataset.sortValue);
      return (av - bv) * dir;
    });

    rows.forEach(row => tbody.appendChild(row));
    this.updateIcon();
  }

  updateIcon() {
    if (!this.hasHeaderTarget) return;
    const icon = this.headerTarget.querySelector(".table-sort-icon");
    if (!icon) return;
    icon.classList.remove("fa-sort-up", "fa-sort-down");
    icon.classList.add(this.directionValue === "asc" ? "fa-sort-up" : "fa-sort-down");
  }
}
